import React from 'react';
import type { FC } from 'react';

interface PictureIconProps {
    className?: string;
}

export const PictureIcon: FC<PictureIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Picture Icon</title>
            <g clipPath="url(#clip0_1568_3658)">
                <path d="M12.5 6.66663H12.51" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M2.5 5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H15C15.663 2.5 16.2989 2.76339 16.7678 3.23223C17.2366 3.70107 17.5 4.33696 17.5 5V15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5H5C4.33696 17.5 3.70107 17.2366 3.23223 16.7678C2.76339 16.2989 2.5 15.663 2.5 15V5Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.66797 13.3333L6.83463 9.16665C7.60797 8.42248 8.5613 8.42248 9.33463 9.16665L13.5013 13.3333"
                    stroke="white"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 11.4998L12.4993 10.8333C13.2727 10.0891 14.226 10.0891 14.9993 10.8333L17.4993 13.3333"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1568_3658">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
